import React, { createContext, useContext, ReactNode, SetStateAction, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import { getParsedSessionStorageItem } from '../../js/script';

// Context를 boolean 타입으로 선언
const AppContext = createContext<{
  storageAppValue: boolean;
  setStorageAppValue: React.Dispatch<SetStateAction<boolean>>;
  appClose: boolean;
  setAppClose: React.Dispatch<SetStateAction<boolean>>;
  direct: boolean;
  setDirect: React.Dispatch<SetStateAction<boolean>>;
  isAppView: boolean;
}>({
  storageAppValue: false,
  setStorageAppValue: () => {},
  appClose: false,
  setAppClose: () => {},
  direct: false,
  setDirect: () => {},
  isAppView: false,
});

interface AppProviderProps {
  children: ReactNode;
}

const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [storageAppValue, setStorageAppValue] = useState<boolean>(false);
  const [appClose, setAppClose] = useState<boolean>(false);
  const [direct, setDirect] = useState<boolean>(false);
  const [isAppView, setIsAppView] = useState<boolean>(false);
  const location = useLocation();
  const pathname = location.pathname;
  const parts = pathname.split('/');
  const lastPart = parts[parts.length - 1];
  const currentUrl = window.location.pathname;

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isAppCheck = userAgent.includes('Aboutfishing/3');
    setIsAppView(isAppCheck);
  }, []);

  useEffect(() => {
    const result = getParsedSessionStorageItem('app');
    setStorageAppValue(result);
  }, [location]);

  return (
    // value에 boolean 값 전달
    <AppContext.Provider
      value={{
        storageAppValue,
        setStorageAppValue,
        appClose,
        setAppClose,
        direct,
        setDirect,
        isAppView,
      }}
    >
      <div
        className={
          appClose
            ? 'wrap'
            : currentUrl === '/exhibitiondetail/' + `${lastPart}` && !isAppView && isMobile
            ? 'wrap applink_bar_on'
            : 'wrap'
        }
      >
        {children}
      </div>
    </AppContext.Provider>
  );
};

const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext 가 AppProvider 안에서 사용되지 않았습니다.');
  }
  return context;
};

export { AppContext, AppProvider, useAppContext };
